import { Button, Grid } from '@mui/material'
import { FormField } from 'global/components/Form'
import { SelectFuncionarios } from 'global/components/Selects'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { reps } from 'service/api'
import { toast } from 'sonner'

import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { ContentGuide } from 'global/guides/ContentGuide'
import { DesassociarFuncionarioRep } from '../modals/DesassociarFuncionario'

export const AssociarFuncionarioForm = () => {
    const { watch } = useFormContext<{ id: number }>()
    const { id } = watch()
    const { data, isLoading } = reps.funcionarios.useFetchById(id)
    const { mutate } = reps.funcionarios.mutations.useCreate({
        invalidateQuery: true,
    })
    const [checkedIds, setCheckedIds] = useState<number[]>([])

    const checked = (data as any)?.FuncionarioReps?.map(
        (item: any) => item.funcionarioId,
    )

    const handleChange = (ids: number[]) => {
        setCheckedIds(ids)
    }

    const handleClick = async () => {
        checkedIds.forEach(funcionarioId =>
            mutate(
                { funcionarioId, repId: id },
                {
                    onSuccess: () => {
                        toast.success('Funcionário associado com sucesso')
                    },

                    onError: () => {
                        toast.error('Erro ao associar funcionário')

                        setCheckedIds(prev => [...prev, funcionarioId])
                    },
                },
            ),
        )

        setCheckedIds([])
    }

    return (
        <Grid container columnSpacing={2} alignItems="start">
            <Grid item xs={9}>
                <SelectFuncionarios
                    form
                    checked={checked}
                    onChange={handleChange}
                    width={'100%'}
                />
            </Grid>
            <Grid item xs={3}>
                <Button
                    color="primary"
                    fullWidth
                    size="large"
                    sx={{
                        height: '48px',
                    }}
                    variant="contained"
                    onClick={handleClick}
                    disabled={checkedIds.length === 0}
                >
                    Associar
                </Button>
            </Grid>

            <Grid item xs={12} height="25rem">
                <ContentGuide.DataGrid
                    loading={isLoading}
                    density="compact"
                    columns={[
                        {
                            field: 'Funcionario',
                            headerName: 'Nome',
                            flex: 1,
                            valueGetter: params => params.row.Funcionario.nome,
                        },
                        {
                            ...optionsColumn,
                            field: '__desassociar',
                            renderCell: DesassociarFuncionarioRep,
                        },
                    ]}
                    rows={(data as any)?.FuncionarioReps ?? []}
                    ToolbarProps={{ hideToolbar: true }}
                />
            </Grid>

            <FormField name="id" hidden />
        </Grid>
    )
}
